<template>
  <nav class="sidebar" v-cloak>
    <div id="menuBar" class="sidebar__bar" @click="toggleSidebar">
      <i class="fa" :class="showSidebar ? 'fa-close' : ' fa-bars'"></i>
    </div>
    <div id="menuWrapper" class="sidebar__list-wrapper" :class="{ 'sidebar__list-wrapper--show': showSidebar }">
      <slot name="content"></slot>
    </div>
  </nav>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  data () {
    return {
      showSidebar: false
    }
  },
  methods: {
    toggleSidebar () {
      this.showSidebar = !this.showSidebar
      if (document.body.clientWidth < 769 && this.showSidebar) {
        document.body.style.overflowY = "hidden"
      } else {
        document.body.style.overflowY = ""
      }
    }
  },
  mounted () {
    let that = this

    const $sidebarSubmenu = document.getElementsByClassName('sidebar__submenu')
    const $currentURL = document.querySelectorAll("#menu > li a")

    window.addEventListener('resize', function (e) {
      if (e.srcElement.innerWidth > 768) {
        [].forEach.call($sidebarSubmenu, function (el) {
          if (el.classList.contains('sidebar__submenu--active')) {
            el.classList.remove('sidebar__submenu--active')
          }
        })
      }
      if (e.srcElement.innerWidth > 767) {
        document.body.style.overflowY = ""
      }
    });

    [].forEach.call($currentURL, function (element) {
      if (window.location.href.split('#')[0].match(element.href)) {
        element.parentElement.classList.add("sidebar__item--active")
        if (element.parentElement.parentElement.parentElement.previousElementSibling !== null) {
          element.parentElement.parentElement.parentElement.previousElementSibling.classList.add("sidebar__submenu-title--active")
        }
        if (element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling !== null) {
          element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling.classList.add("sidebar__submenu-title--active")
        }
      }
    });

  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/layout/menu/MainMenu.vue